package music.jammers.client.shared.auth.domain.usecase

import music.jammers.client.shared.auth.domain.repository.AuthRepository
import music.jammers.client.shared.auth.domain.repository.TokenRepository
import music.limasoul.client.shared.user.domain.repository.UserRepository

class LogoutUseCase(
    private val authRepository: AuthRepository,
    private val userRepository: UserRepository,
    private val tokenRepository: TokenRepository,
) {

    suspend operator fun invoke() {
        authRepository.logout()
        tokenRepository.clear()
        userRepository.clear()
    }
}